import { render, staticRenderFns } from "./VerifyAddress.vue?vue&type=template&id=23e98826&"
import script from "./VerifyAddress.vue?vue&type=script&lang=js&"
export * from "./VerifyAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports